import React from "react";
import { Helmet } from "react-helmet-async";

function PrivacyPolicy() {
  return (
    <div className="p-privacy-policy-main">
      <Helmet>
        <title>Privacy Policy Koios Bangalore</title>
        <meta
          name="description"
          content="Koios Engineering privacy policy: protecting client data, compliance with Indian and global standards."
        />
      </Helmet>
      <h1>Privacy Policy Koios Engineering</h1>
      <br />
      <br />
      <h1 className="p-privacy-policy-text">PRIVACY POLICY</h1>
      <br />
      <br />
      <br />
      <br />
      <p>
        This Privacy Policy describes how Koios Engineering Solutions (&ldquo;Koios&rdquo;,
        &ldquo;we&rdquo;, &ldquo;us&rdquo; or &ldquo;our&rdquo;) collects, uses, shares and protects personal
        information when you interact with our website. It also explains the
        choices you have and how you can contact us about your personal
        information. This policy applies to the website operated by Koios
        Engineering Solutions.
      </p>

      <br />
      <br />

      <h2>WHO is Responsible for the Processing of Your Personal Data?</h2>

      <br />
      <p>
        Koios Engineering Solutions is responsible for the processing of the
        personal data described in this Privacy Policy. We are an engineering
        services company based in Bangalore, Karnataka, India, offering services
        such as general engineering, vehicle development, automotive design and
        manufacturing, electric vehicle development, 3D scanning and 3D printing.
        When this policy refers to &ldquo;we&rdquo;, &ldquo;us&rdquo; or &ldquo;our&rdquo;, it means Koios
        Engineering Solutions.
      </p>

      <br />
      <br />

      <h2>WHAT Personal Data Do We Collect and WHEN?</h2>

      <br />
      <p>
        We collect personal data that you choose to provide to us and certain
        information that is collected automatically when you use our website.
      </p>
      <br />
      <p>
        Information you provide to us. When you contact us through the contact
        form on our website, we ask for your full name, email address, mobile
        number and the details of your enquiry (the message you submit). We also
        collect information when you reach out to us by phone, email or through
        the WhatsApp chat link made available on our website.
      </p>
      <br />
      <p>
        Information collected automatically. When you visit our website, certain
        technical information may be collected automatically, such as your IP
        address, browser type, device information, pages viewed and general usage
        data. We use Google Analytics to help us understand how visitors use our
        website and to improve its performance.
      </p>
      <br />
      <p>
        We do not require you to create an account on our website and we do not
        collect payment or financial information through this website.
      </p>

      <br />
      <br />

      <h2>WHY and HOW Do We Use Your Personal Data?</h2>

      <br />
      <p>We use your personal data in the following ways:</p>
      <br />
      <p>
        i) To respond to your enquiries and provide the services you request.
        When you submit our contact form or otherwise get in touch, we use the
        information you provide to respond to your enquiry, discuss your
        requirements and provide the engineering services you ask for.
      </p>
      <br />
      <p>
        ii) To communicate with you. We may use your contact details to follow up
        on your enquiry, share information you have requested and communicate
        about the services we provide. We do not send marketing or promotional
        communications to you unless you have asked to receive them, and you can
        opt out at any time.
      </p>
      <br />
      <p>
        iii) To operate, improve and maintain our website and services. We use
        the information we collect to operate our website, understand how it is
        used, improve its performance and maintain the security of our systems.
      </p>

      <br />
      <br />

      <h2>Cookies and Tracking Technologies</h2>

      <br />
      <p>
        Our website uses Google Analytics, a web analytics service provided by
        Google, to help us understand how visitors use the site. Google
        Analytics may use cookies and similar technologies to collect technical
        information such as your IP address, browser and device information and
        the pages you visit. This information is used in an aggregated form to
        analyse website usage.
      </p>
      <br />
      <p>
        You can control or disable cookies through your browser settings. Please
        note that if you disable cookies, some parts of the website may not
        function as intended. You can learn more about how Google uses your data
        and how to manage your preferences by visiting Google&rsquo;s privacy policy
        and the Google Analytics opt-out options.
      </p>

      <br />
      <br />

      <h2>HOW Do We Share Information?</h2>

      <br />
      <p>
        We do not sell your personal information. We may share personal
        information with service providers who help us operate our website and
        respond to enquiries. These include our form-handling provider, which
        processes the submissions made through our contact form on our behalf,
        our analytics and font providers, and our website hosting provider.
      </p>
      <br />
      <p>
        We may also disclose personal information where required to do so by
        applicable law, regulation, legal process or a valid request from a
        public authority, or where necessary to protect our rights, property or
        safety.
      </p>

      <br />
      <br />

      <h2>Third-Party Services</h2>

      <br />
      <p>
        Our website relies on certain third-party services. These third parties
        may process information in connection with operating their services and
        are governed by their own privacy policies.
      </p>
      <br />
      <p>
        i) Formspree &ndash; used to process the information submitted through our
        contact form.
      </p>
      <br />
      <p>
        ii) Google Analytics &ndash; used to measure and analyse website usage.
      </p>
      <br />
      <p>
        iii) Google Fonts &ndash; used to display fonts on our website.
      </p>
      <br />
      <p>
        iv) WhatsApp &ndash; our website includes a link that opens a WhatsApp chat
        with us. If you choose to use it, your interaction is subject to
        WhatsApp&rsquo;s own privacy policy.
      </p>

      <br />
      <br />

      <h2>Data Retention</h2>

      <br />
      <p>
        We retain personal information for as long as reasonably necessary to
        fulfil the purposes described in this Privacy Policy, to comply with our
        legal obligations, to resolve disputes and to enforce our agreements.
        When personal information is no longer needed for these purposes, we take
        reasonable steps to delete or anonymise it.
      </p>

      <br />
      <br />

      <h2>Data Security</h2>

      <br />
      <p>
        We take reasonable technical and organisational measures designed to
        protect personal information against unauthorised access, disclosure,
        alteration or destruction. Our website is served over a secure HTTPS
        connection. Please note that no method of transmission over the internet
        or method of electronic storage is completely secure, and we cannot
        guarantee absolute security.
      </p>

      <br />
      <br />

      <h2>Children&rsquo;s Privacy</h2>

      <br />
      <p>
        Our website and services are intended for businesses and professional
        users and are not directed at children. We do not knowingly collect
        personal information from children. If you believe that a child has
        provided personal information to us, please contact us and we will take
        reasonable steps to delete it.
      </p>

      <br />
      <br />

      <h2>YOUR Rights Relating to Your Personal Data</h2>

      <br />
      <p>
        Depending on your location and applicable law, you may have rights
        regarding your personal information. These may include the right to
        request access to the personal information we hold about you, to request
        correction of information that is incomplete or inaccurate, to request
        deletion of your information, to withdraw any consent you have given, or
        to object to or restrict certain processing. You may also ask us to stop
        sending you communications at any time. These rights are not absolute and
        may be subject to legal limits.
      </p>
      <br />
      <p>
        To exercise any of these rights, please contact us using the details in
        the &ldquo;Contact Us&rdquo; section below. We will assess your request and respond
        in a timely and effective manner.
      </p>

      <br />
      <br />

      <h2>International Data Transfers</h2>

      <br />
      <p>
        Some of our service providers may process personal information in
        countries other than your own. Where required by applicable law, we take
        reasonable steps in relation to such transfers and rely on our service
        providers&rsquo; safeguards.
      </p>

      <br />
      <br />

      <h2>Links to Third-Party Websites</h2>

      <br />
      <p>
        Our website may contain links to third-party websites, including our
        social media pages and WhatsApp. We are not responsible for the privacy
        practices or the content of those websites. We encourage you to review
        the privacy policy of any website you visit.
      </p>

      <br />
      <br />

      <h2>CHANGES to Our Privacy Policy</h2>

      <br />
      <p>
        Applicable law and our practices change over time. If we decide to update
        this Privacy Policy, we will post the changes on our website. Where we
        make material changes to the way we process your personal information, we
        will provide prior notice or, where legally required, request your
        consent before implementing such changes. We encourage you to read this
        Privacy Policy and keep yourself informed of our practices. This Privacy
        Policy was last updated in October 2026.
      </p>

      <br />
      <br />

      <h2>Contact Us</h2>

      <br />
      <p>
        We welcome questions, comments and concerns about this Privacy Policy and
        our privacy practices. If you wish to provide feedback, have questions or
        concerns, or wish to exercise your rights related to your personal data,
        please contact us through the &ldquo;Contact Us&rdquo; section of our website or by
        email at info@koiosengg.com.
      </p>
      <br />
      <p>
        Koios Engineering Solutions, No.315/64, Mallasandra village, off holiday
        village road, Thalaghattapura, Bangalore, Bangalore South, Karnataka,
        India - 560109. Phone: +91 63616 68024.
      </p>
      <br />
      <p>
        If you contact us with a privacy complaint, it will be assessed with the
        aim of resolving the issue in a timely and effective manner.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
